import { connect } from 'react-redux'
import Inventory from './Inventory'
import { getInventoryData } from './module'
import { handleOnNavClick as handleOnEkgReviewInboxClick } from '../../pages/EkgReview/module'
import { getDataSource } from '../../store/appReducer'
import { DATASOURCES } from '../../constants'

const mapActionCreators = { getInventoryData }

const mapStateToProps = state => {
  const { inventory } = state

  return {
    dataIsFetching: inventory.dataIsFetching,
    dataLastUpdated: inventory.dataLastUpdated,
    me: getDataSource(state, DATASOURCES.ME),
    inventory: getDataSource(state, DATASOURCES.INVENTORY),
  }
}

export default connect(mapStateToProps, mapActionCreators)(Inventory)



// WEBPACK FOOTER //
// ./src/legacy/pages/Inventory/container.js